import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Typography, Grid, Button } from "@material-ui/core";
import { ackPayment } from "../../redux/actions";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { GetAPI } from "../../tools/GetAPI";
import fetchWithTimeout from "../../tools/fetchWithTimeout";

function getModalStyle() {
  return {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function AckPaymentModal(props) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [displayBackdrop, setDisplayBackdrop] = React.useState(false);

  const handleClick = async () => {
    setDisplayBackdrop(true);

    const URI = `${GetAPI()}/orders/payment`;
    fetchWithTimeout(URI, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: props.orderId }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        props.ackPayment(props.orderId);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setDisplayBackdrop(false);
        props.handleClose();
      });
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div style={modalStyle} className={classes.paper}>
        <Grid
          container
          direction={"column"}
          justify={"center"}
          alignItems={"center"}
          spacing={3}
          style={{ marginTop: 5 }}
        >
          <Grid item>
            <Typography variant={"h6"}>
              Acknowledge payment for order #{props.orderId}
            </Typography>
          </Grid>
          <Grid item>
            <Button
              variant={"contained"}
              color={"primary"}
              size={"large"}
              onClick={handleClick}
            >
              Acknowledge
            </Button>
          </Grid>
        </Grid>
        <Backdrop className={classes.backdrop} open={displayBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </Modal>
  );
}

AckPaymentModal.propTypes = {
  orderId: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default connect(null, { ackPayment: ackPayment })(AckPaymentModal);



// WEBPACK FOOTER //
// ./src/components/modals/AckPaymentModal.js